import {
    FETCH_ERROR, FETCH_SUCCESS, FETCH_START,
} from "../types"
import axios from "../../services/Api";
import Cookies from 'js-cookie';
import { useApplyTheme } from "../../utils/hooks";


export const forgotPasswordCase = (payload, cb) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        axios.post('users/forgotPassword', {
            ...payload
        }
        ).then(({ data }) => {
            if (data.success) {
                dispatch({ type: FETCH_SUCCESS });
            }
            else {
                dispatch({ type: FETCH_ERROR, payload: data.message });
            }
            if (cb) {
                cb(data)
            }

        }).catch(function (error) {
            dispatch({ type: FETCH_ERROR, payload: error.message });
            if (cb) {
                cb({ success: false, message: error.message })
            }
        });
    }
};

export const verifyOTPCase = (payload, cb) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        axios.post('users/verifyOtp', {
            ...payload
        }
        ).then(({ data }) => {
            if (data.success) {
                dispatch({ type: FETCH_SUCCESS });
            }
            else {
                dispatch({ type: FETCH_ERROR, payload: data.message });
            }
            if (cb) {
                cb(data)
            }

        }).catch(function (error) {
            dispatch({ type: FETCH_ERROR, payload: error.message });
            if (cb) {
                cb({ success: false, message: error.message })
            }
        });
    }
};
export const changePasswordCase = (payload, cb) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        axios.post('users/changePassword', {
            ...payload
        }
        ).then(({ data }) => {
            if (data.success) {
                dispatch({ type: FETCH_SUCCESS });
            }
            else {
                dispatch({ type: FETCH_ERROR, payload: data.message });
            }
            if (cb) {
                cb(data)
            }

        }).catch(function (error) {
            dispatch({ type: FETCH_ERROR, payload: error.message });
            if (cb) {
                cb({ success: false, message: error.message })
            }
        });
    }
};

export const resendOtpFor2FA = (payload, cb) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        axios.post('users/resendOtp', {
            ...payload
        }
        ).then(({ data }) => {
            if (data.success) {
                dispatch({ type: FETCH_SUCCESS });
            }
            else {
                dispatch({ type: FETCH_ERROR, payload: data.message });
            }
            if (cb) {
                cb(data)
            }

        }).catch(function (error) {
            dispatch({ type: FETCH_ERROR, payload: error.message });
            if (cb) {
                cb({ success: false, message: error.message })
            }
        });
    }
};
export const verifyOtpFor2FA = (payload, cb) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        axios.post('users/verifyOtpTwoFactorLogin', {
            ...payload
        }
        ).then(({ data }) => {
            if (data.success) {
                dispatch({ type: FETCH_SUCCESS });
            }
            else {
                dispatch({ type: FETCH_ERROR, payload: data.message });
            }
            if (cb) {
                cb(data)
            }

        }).catch(function (error) {
            dispatch({ type: FETCH_ERROR, payload: error.message });
            if (cb) {
                cb({ success: false, message: error.message })
            }
        });
    }
};

export const getCentralTheming = (payload, cb) => {
  try {
    const cachedData = localStorage.getItem("centralTheming");

    if (cachedData) {
      const parsed = JSON.parse(cachedData);

      useApplyTheme(parsed);

      if (cb) cb(parsed);

      return { type: FETCH_SUCCESS };
    }

    return (dispatch) => {
      dispatch({ type: FETCH_START });

      axios.get("base/getTheme", { params: payload })
        .then(({ data }) => {

          if (data?.success && data?.data) {
            dispatch({ type: FETCH_SUCCESS });

            localStorage.setItem(
              "centralTheming",
              JSON.stringify(data.data)
            );

            useApplyTheme(data.data || {});

            window.dispatchEvent(new Event("themeChange"));

            if (cb) cb(data.data);
          } else {
            dispatch({ type: FETCH_ERROR, payload: data?.message });

            localStorage.removeItem("centralTheming");

            useApplyTheme({});

            if (cb) cb(null);
          }
        })
        .catch((error) => {
          dispatch({ type: FETCH_ERROR, payload: error.message });

          localStorage.removeItem("centralTheming");

          useApplyTheme({});

          if (cb) cb(null);
        });
    };
  } catch (error) {
    console.log(error);

    localStorage.removeItem("centralTheming");

    useApplyTheme({});

    if (cb) cb(null);
  }
};